module.exports = __webpack_public_path__ + "img/out_stock_icon.8c3069a9.png";